module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition-group', {
    class: ['el-upload-list', 'el-upload-list--' + _vm.listType],
    attrs: {
      "tag": "ul",
      "name": "el-list"
    }
  }, _vm._l((_vm.files), function(file) {
    return _c('li', {
      key: file,
      class: ['el-upload-list__item', 'is-' + file.status]
    }, [(file.status !== 'uploading' && ['picture-card', 'picture'].indexOf(_vm.listType) > -1) ? _c('img', {
      staticClass: "el-upload-list__item-thumbnail",
      attrs: {
        "src": file.url,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "el-upload-list__item-name",
      on: {
        "click": function($event) {
          _vm.handleClick(file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-document"
    }), _vm._v(_vm._s(file.name) + "\n    ")]), _vm._v(" "), _c('label', {
      staticClass: "el-upload-list__item-status-label"
    }, [_c('i', {
      class: {
        'el-icon-upload-success': true,
        'el-icon-circle-check': _vm.listType === 'text',
          'el-icon-check': ['picture-card', 'picture'].indexOf(_vm.listType) > -1
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          _vm.$emit('remove', file)
        }
      }
    }), _vm._v(" "), (file.status === 'uploading') ? _c('el-progress', {
      attrs: {
        "type": _vm.listType === 'picture-card' ? 'circle' : 'line',
        "stroke-width": _vm.listType === 'picture-card' ? 6 : 2,
        "percentage": _vm.parsePercentage(file.percentage)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.listType === 'picture-card') ? _c('span', {
      staticClass: "el-upload-list__item-actions"
    }, [(_vm.handlePreview && _vm.listType === 'picture-card') ? _c('span', {
      staticClass: "el-upload-list__item-preview",
      on: {
        "click": function($event) {
          _vm.handlePreview(file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-view"
    })]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "el-upload-list__item-delete",
      on: {
        "click": function($event) {
          _vm.$emit('remove', file)
        }
      }
    }, [_c('i', {
      staticClass: "el-icon-delete2"
    })])]) : _vm._e()], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a76a855!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader/src/upload-list.vue
// module id = 605
// module chunks = 0